import { navigate } from 'gatsby';

export function openLightbox(location, { fluids, index }) {
  navigate(location.pathname, { state: { lightbox: { fluids, index } } });
}
